import { render, staticRenderFns } from "./CarouselNavPrevBT.vue?vue&type=template&id=70d8cf08&scoped=true"
import script from "./CarouselNavPrevBT.vue?vue&type=script&lang=js"
export * from "./CarouselNavPrevBT.vue?vue&type=script&lang=js"
import style0 from "./CarouselNavPrevBT.vue?vue&type=style&index=0&id=70d8cf08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8cf08",
  null
  
)

export default component.exports